"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveFilterSliderProps = void 0;

var react_1 = __importDefault(require("react"));

var useReactiveFilterSharedProps_1 = require("./useReactiveFilterSharedProps");
/**
 * For use with @appbaseio/reactivesearch RangeSlider component
 */


var useReactiveFilterSliderProps = function useReactiveFilterSliderProps(filter) {
  var reactiveFilterSharedProps = (0, useReactiveFilterSharedProps_1.useReactiveFilterSharedProps)(filter);
  var rangeLabelsFn = react_1.default.useCallback(function (min, max) {
    var _a, _b, _c, _d;

    return {
      start: "".concat((_a = filter.displaySliderPrefix) !== null && _a !== void 0 ? _a : "").concat(min).concat((_b = filter.displaySliderSuffix) !== null && _b !== void 0 ? _b : ""),
      end: "".concat((_c = filter.displaySliderPrefix) !== null && _c !== void 0 ? _c : "").concat(max).concat((_d = filter.displaySliderSuffix) !== null && _d !== void 0 ? _d : "")
    };
  }, []);
  var reactiveFilterSliderProps = react_1.default.useMemo(function () {
    var _a, _b;

    return Object.assign(Object.assign({}, reactiveFilterSharedProps), {
      showFilter: (_a = filter.settingsShowFilter) !== null && _a !== void 0 ? _a : true,
      rangeLabels: rangeLabelsFn,
      stepValue: (_b = parseInt(filter.displaySliderStep)) !== null && _b !== void 0 ? _b : undefined
    });
  }, [filter, reactiveFilterSharedProps]);
  return reactiveFilterSliderProps;
};

exports.useReactiveFilterSliderProps = useReactiveFilterSliderProps;